import { Button, Modal } from "antd";
import React, { useRef, useState } from "react";
import { FormLabel } from "react-bootstrap";
import TextInfo from "../../../../components/common/TextInfo/TextInfo";
import TextInput from "../../../../components/common/TextInput/TextInput";
import IsEmpty from "../../../../components/helpers/IsEmpty";
import "../styles.css";
import { Select, Radio } from "antd";
import { initCondition } from "../constants";
import ErrorDiv from "../../../../components/helpers/ErrorDiv";
const { Option } = Select;

export default function ModalAddlListNotification({
  visible,
  submitting,
  handleClose,
  variableList,
  handleAddList,
  insertVariable,
  handleText,
  form,
  setForm,
  defaultValue,
}) {
  const scriptRef = useRef(null);

  const converLabelVariable = (label) => {
    return label.substring(1, label.length - 1);
  };

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (IsEmpty(form.title)) {
      newErrors.title = "Judul tidak boleh kosong";
    }
    if (IsEmpty(form.days)) {
      newErrors.days = "Hari pengiriman tidak boleh kosong";
    }
    if (IsEmpty(form.desc)) {
      newErrors.desc = "Skrip tidak boleh kosong";
    }
    if (IsEmpty(form.condition)) {
      newErrors.condition = "Kondisi tidak boleh kosong";
    }
    return newErrors;
  };

  const onSubmit = () => {
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      setErrors({});
      handleAddList();
    }
  };

  const onClose = () => {
    handleClose();
    setErrors({});
  };

  const onChangeRadio = (data) => {
    setForm((prev) => ({
      ...prev,
      condition: data.target.value,
    }));
  };

  return (
    <Modal
      title={"Tambah Daftar Pengiriman Notifikasi"}
      visible={visible}
      onCancel={onClose}
      width={700}
      centered
      footer={[
        <Button
          disabled={submitting}
          key="back"
          onClick={onClose}
          className="btn-modal btn-default"
          style={{ width: "15%" }}
        >
          Kembali
        </Button>,
        <Button
          disabled={submitting}
          key="submit"
          type="primary"
          onClick={onSubmit}
          className="btn-modal"
          style={{ width: "15%" }}
        >
          {form.index != undefined ? "Ubah" : "Simpan"}
        </Button>,
      ]}
    >
      <div className="py-2">
        <div className="d-flex">
          <div className="col-6 pl-0">
            <FormLabel className="modal-title mb-2">Judul Notifikasi</FormLabel>
            <div className="mt-1">
              <TextInput
                width="100%"
                value={form.title}
                type={"input"}
                id={"title"}
                handleChange={handleText}
                errorText={errors?.title}
                isForm
              />
            </div>
          </div>

          <div className="col-6 pr-0">
            <FormLabel className="modal-title mb-2">
              Waktu Pengiriman Notifikasi
            </FormLabel>
            <div className="d-flex">
              <div className="mt-1">
                <TextInput
                  width="100%"
                  value={form.days}
                  type={"input"}
                  id={"days"}
                  handleChange={handleText}
                  errorText={errors?.days}
                  inputType="number"
                  isForm
                />
              </div>
              <Select
                style={{ width: 80, marginBottom: 25 }}
                onChange={(e) => setForm({ ...form, unit: e })}
                defaultValue={defaultValue}
                value={form.unit || "day"}
                className="select-after"
              >
                <Option value="day">Hari</Option>
                <Option value="hour">Jam</Option>
                <Option value="minute">Menit</Option>
              </Select>
            </div>
          </div>
        </div>
        <div className="px-0 mb-3">
          <FormLabel className="modal-title mb-2">Kondisi</FormLabel>
          <Radio.Group
            onChange={(e) => onChangeRadio(e)}
            value={form?.condition}
            className="w-100"
          >
            {initCondition.map((item, index) => {
              return (
                <Radio key={index} value={item.value}>
                  {item.label}
                </Radio>
              );
            })}
          </Radio.Group>
          {errors.condition && (
            <p className="text-danger small">Kondisi harus dipilih</p>
          )}
        </div>
        <div>
          <TextInfo
            isStyleBlock
            title="Skrip Notifikasi"
            value={form.desc}
            isTextArea
            type={"input"}
            id={"desc"}
            handleChange={handleText}
            error={errors?.desc}
            placeholder={"Masukkan skrip"}
            isForm
            ref={scriptRef}
          />
        </div>
        <div className="d-flex">
          {variableList.map((item, index) => {
            return (
              <div
                className="custom-button"
                key={index}
                onClick={() => insertVariable(item.key)}
              >
                {converLabelVariable(item.key)}
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
}
